<div class="container">
  <mat-card-title class="mat-card-title">Device Details</mat-card-title>
  <hr class="horizontal-line">
  <div fxLayout="row">
    <div fxFlex="25" class="device-div">
      <div class="model-title-div">
        <span id="device-model" class="model-name">{{capitalizeFirstLetter(deviceModel)}}</span>
        <div id="device-label" class="ng-binding device-value">{{deviceType}}</div>
      </div>
      <hr class="horizontal-line">

      <div class="device-detail-div">
        <div *ngIf=!isSmartFxDevice()>
          <mat-card-header class="detail-label">{{ getLastActiveLabel() }} :</mat-card-header>
          <mat-card-content id="device-lastseen">{{ getLastActiveValue() }}</mat-card-content>
        </div>

        <mat-card-header class="detail-label">Serial Number :</mat-card-header>
        <mat-card-content id="device-serialnumber">{{deviceSerialnumber}}</mat-card-content>

        <mat-card-header class="detail-label">Device ID</mat-card-header>
        <mat-card-content id="device-label" class="ng-binding">{{deviceID}}</mat-card-content>
      </div>
    </div>

    <div fxFlex="75" fxLayout="column">
      <div>
        <mat-card>
          <mat-card-header class="header">
            <mat-card-title class="mat-card-info" (click)="deviceInfoToggle=!deviceInfoToggle"><a
                href="javascript:">Device Info</a></mat-card-title>
          </mat-card-header>
        </mat-card>

        <div class="device-info-container" *ngIf="deviceInfoToggle">
          <div class="device-detail">
            <div class="detail-label">Device Name</div>
            <div id="device-label" class="ng-binding device-value">{{capitalizeFirstLetter(deviceLabel)}}</div>
          </div>

          <div class="device-detail">
            <div class="detail-label">Room Type</div>
            <div id="device-label" class="ng-binding device-value">{{capitalizeFirstLetter(roomType)}}</div>
          </div>

          <div class="device-detail">
            <div class="detail-label">Property Name</div>
            <div id="device-label" class="ng-binding device-value">{{capitalizeFirstLetter(propertyName)}}</div>
          </div>

          <div class="device-detail">
            <div class="detail-label">Location ID</div>
            <div id="detail-label" class="ng-binding device-value"><a
                [routerLink]="'/location/'+ deviceLocationID">{{deviceLocationID}}</a></div>
          </div>

          <div *ngIf=!isSmartFxDevice() fxLayout="row">
            <div class="device-detail">
              <div class="detail-label">Alarm Version</div>
              <div id="device-label" class="ng-binding device-value">{{alarmVersion}}</div>
            </div>

            <div class="device-detail">
              <div class="detail-label">Net Version</div>
              <div id="device-label" class="ng-binding device-value">{{netVersion}}</div>
            </div>

            <div class="device-detail">
              <div class="detail-label">Firmware Version</div>
              <div id="device-label" class="ng-binding device-value">{{firmwareVersion}}</div>
            </div>

            <div class="device-detail">
              <div class="detail-label">Offline</div>
              <div id="device-label" class="ng-binding device-value">{{displayValueOffline(offline)}}</div>
            </div>

            <div class="device-detail">
              <div class="status-label-container">
                <div class="detail-label">Status<mat-icon [matTooltip]="getTooltip('contactLost')"
                    matTooltipPosition="right" class="info-icon">info</mat-icon></div>
              </div>
              <div id="device-label" class="ng-binding status-device-value"
                [ngClass]="{'status-active': status === 'ACTIVE', 'status-inactive': status !== 'ACTIVE'}">
                {{status}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div fxFlex="75">
        <div fxFlex="100">
          <mat-card>
            <mat-card-header class="header">
              <mat-card-title class="mat-card-info" (click)="deviceDetailToggle=!deviceDetailToggle"><a
                  href="javascript:">Device Details</a></mat-card-title>
            </mat-card-header>
            <mat-card-content *ngIf="deviceDetailToggle">
              <div class="device-details-container">
                <ng-container *ngFor="let key of boldFontParameters">
                  <div *ngIf="flattenedData.hasOwnProperty(key)" class="card-header-and-content">
                    <mat-card-header class="bold-font" [matTooltip]="getTooltip(key)">
                      {{ capitalizeFirstLetter(key) }}
                    </mat-card-header>
                    <mat-card-content class="device-value"
                      [ngClass]="key === 'Signal Strength (AP RSSI)' ? getSignalStrengthClass(flattenedData[key]).class : ''"
                      [matTooltip]="key === 'Signal Strength (AP RSSI)' ? getSignalStrengthClass(flattenedData[key]).tooltip : ''">
                      {{ displayValue(flattenedData[key]) }}
                    </mat-card-content>
                  </div>
                </ng-container>

                <div *ngIf="!showAllParameters">
                  <span class="show-more" (click)="toggleShowAllParameters()">Click here to show more</span>
                </div>

                <ng-container *ngIf="showAllParameters">
                  <ng-container *ngFor="let item of flattenedData | keyvalue">
                    <div *ngIf="!boldFontParameters.includes(item.key)" class="card-header-and-content">
                      <mat-card-header class="grey-font" [matTooltip]="getTooltip(item.key)">
                        {{ capitalizeFirstLetter(item.key) }}
                      </mat-card-header>
                      <mat-card-content class="grey-font"
                        [ngClass]="item.key === 'Signal Strength (AP RSSI)' ? getSignalStrengthClass(item.value).class : ''"
                        [matTooltip]="item.key === 'Signal Strength (AP RSSI)' ? getSignalStrengthClass(item.value).tooltip : ''">
                        {{ displayValue(item.value) }}
                      </mat-card-content>
                    </div>
                  </ng-container>
                  <span class="show-more" (click)="toggleShowAllParameters()">Show less</span>
                </ng-container>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>